export default __webpack_public_path__ + "static/media/arrival-banner-5.68e484ee.webp";